import { useLang } from "../../context/LangContext";
import { money } from "../../lib/api";

export const Price = ({ price, final, className = "", testid }) => {
  const { t } = useLang();
  const onSale = final < price;
  return (
    <span data-testid={testid} className={`inline-flex items-baseline gap-2 ${className}`}>
      <span className={onSale ? "text-gold-deep" : ""}>{money(final)} {t("sar")}</span>
      {onSale && <s className="text-[0.85em] text-sand-dark">{money(price)}</s>}
    </span>
  );
};
